<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          <CCol class="col-md-6 float-left" >
            Users Details
          </CCol>
          <CCol class="col-md-6 float-right">
            <CButton color="primary" @click="redirectUrls('/users-list')" class="px-4 float-right" type="">Back</CButton>
          </CCol>
        </CCardHeader>
        <CCardBody>
          <loading :active.sync="isLoading"
          :can-cancel="false" :is-full-page="fullPage"></loading>
          <CCardHeader>
            <b>First name</b>: {{resources.firstname}}
          </CCardHeader>
          <CCardHeader>
            <b>Last name</b>: {{resources.lastname}}
          </CCardHeader>
          <CCardHeader>
            <b>Phone</b>: {{resources.countrycode}} {{resources.phone}}
          </CCardHeader>
          <CCardHeader>
            <b>Email</b>: <span v-if="resources.email">{{resources.email}}</span><span v-else>No email</span>
          </CCardHeader>
          <CCardHeader>
            <b>Social media</b>: <ul v-if="resources.socialmedia && resources.socialmedia.length" id="task-list">
            <li v-for="socialmedia in resources.socialmedia" v-bind:key="socialmedia._id">
              {{ socialmedia.socialMediaName }}: {{ socialmedia.url }}
            </li>
          </ul>
          <p v-else>No links</p>
          </CCardHeader>
          <CCardHeader>
            <b>Profile picture</b>: <img slot="profilepicture" style="width: 100px; height: 100px;" slot-scope="" :src="resources.image_url" @error="$event.target.src = APP_URL+'no_image.png'" />
          </CCardHeader>
          <CCardHeader>
            <b>Report Count</b>: <span v-if="resources.countReport">{{resources.countReport}}</span><span v-else>0</span>
          </CCardHeader>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import VueNotifications from 'vue-notifications'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    name: 'userDetails',
    data() {
        return {
            showAddBtn: true,
            isLoading: false,
            APP_URL: APP_URL,
            fullPage: true,
            resources: [],
            columns: ['firstname', 'lastname', 'phone'],
            activeOptions: [{id: 0, text: 'Deactive'}, {id: 1, text: 'Active'}],
            selectedOption: '0',
            token: localStorage.getItem('token'),
            tokenChange: JSON.parse(localStorage.getItem('token')),
            options: {
              sortable: ['firstname'],
              sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              pagination: {
                chunk: 5,
                edge: false,
                nav: 'scroll'
              }
            }
        }
    },
    components: {
        Loading
    },
    notifications: {
        showErrorMsg: {
            type: VueNotifications.types.error
        },
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
    components: {
        Loading
    },
    created() {
        document.title = "User detail";
        this.loadData();
    },
    methods: {
        loadData() {
            let id = this.$route.params.id
            this.isLoading = true;
            axios.get(`${API_ADMIN_URL}/usersDetails/`+id, {headers: {'x-access-token': this.tokenChange}}).then(response => {
                if (response.data.status == 200) {
                    this.resources = response.data.data;
                    this.isLoading = false;
                } else {
                    this.isLoading = false;
                    localStorage.clear();
                    this.$router.push('/login');
                }
            });
        },
        redirectUrls: function(link) {
            this.$router.push(link);
        }
    }
}
</script>
